<template>
<div class="content2">
  <div>
    <el-date-picker
      style="width: 150px"
      v-model="where.yaer_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="计划月份">
    </el-date-picker>
    <el-button size="mini" type="primary" @click="initUrgeType(1)">校准自催计划</el-button>
    <el-button size="mini" type="primary" @click="initUrgeType(3)">校准第三方催费计划</el-button>
    <el-button size="mini" @click="getIndex2Excel()">导出</el-button>
  </div>
<!--  <div class="header-tip">-->
<!--    -->
<!--  </div>-->

  <div class="table-wrap">
    <el-table
      v-loading="loading"
      :data="tableData"
      :span-method="objectSpanMethod"
      border
      style="width: 100%" height="60vh">
      <el-table-column
        prop="name"
        label="名称"
        width="200" align="center">
      </el-table-column>
      <el-table-column
        prop="age_type_text"
        label="账龄类型" width="120" align="center">
      </el-table-column>
      <el-table-column
        label="自催计划" align="center">
        <el-table-column
          prop="zc_count"
          label="户数" min-width="100" align="center" :formatter="intMilFormatter">
          <template slot-scope="scope">
            <el-link type="primary" @click="openLog(scope.row,1)">{{scope.row.zc_count}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="zc_money"
          label="金额" min-width="100" align="center" :formatter="milFormatter"></el-table-column>
      </el-table-column>
<!--      <el-table-column-->
<!--        label="诉讼计划" align="center">-->
<!--        <el-table-column-->
<!--          prop="ss_count"-->
<!--          label="户数" align="center">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="ss_money"-->
<!--          label="金额" align="center">-->
<!--        </el-table-column>-->
<!--      </el-table-column>-->
      <el-table-column
        label="第三方催费申请" align="center">
        <el-table-column
          prop="ds_count"
          label="户数" min-width="100" align="center" :formatter="intMilFormatter">
          <template slot-scope="scope">
            <el-link type="primary" @click="openLog(scope.row,2)">{{scope.row.ds_count}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="ds_money"
          label="金额" min-width="100" align="center" :formatter="milFormatter"></el-table-column>
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间" width="150" align="center">
      </el-table-column>
      <el-table-column
        prop="update_time"
        label="修改时间" width="150" align="center">
      </el-table-column>
    </el-table>
    <HouseUrgeLockHistoryDialog ref="houseUrgeLockHistoryDialogRef" />
    <ConfirmDialog ref="ConfirmDialogRef" />
  </div>
</div>
</template>

<script>
import moment from "moment/moment";
import Http from "../../common/Http";
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";
import HouseUrgeLockHistoryDialog from "./HouseUrgeLockHistoryDialog";
import ConfirmDialog from "../common/ConfirmDialog";

export default {
  name: "LegalHouseAge",
  inject:['where','reginWhere'],
  components: {
    ConfirmDialog,
    HouseUrgeLockHistoryDialog
  },
  data(){
    return{
      loading: false,
      where:{
        yaer_month: moment(new Date()).format("YYYY-MM"),
      },
      where2:{
        order_by:"",
        level_name:""
      },
      tableData:[],
    }
  },
  mounted() {
    const that=this;
    that.getList();
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_region_level) where.region_level=that.reginWhere.project_region_level;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      where.level=that.reginWhere.level;

      ButlerHttp.post("HouseUrgeAge/index2",{
        ...where,
      },res => {
        if (res.code) {
          that.tableData = res.data
        }
        that.loading = false;
      })
    },
    pageChange() {
      const that=this;
      CommonHelp.debounce(()=>{
        that.getList()
      },1000,that);
    },
    round(val,num=2) {
      return Math.round(val*100)/100
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const prevRow = this.tableData[rowIndex - 1];
        const currRow = row;

        if (prevRow && prevRow[column.property] === currRow[column.property]) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i][column.property] === currRow[column.property]) {
              rowspan++;
            } else {
              break;
            }
          }
          if (rowspan > 1) {
            return { rowspan: rowspan, colspan: 1 };
          }
        }
      }
    },
    getIndex2Excel() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_region_level) where.region_level=that.reginWhere.project_region_level;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      where.level=that.reginWhere.level;

      ButlerHttp.post("HouseUrgeAge/getIndex2Excel",{
        ...where,
      },res => {
        if (res.code) {
          window.open(res.data)
        }
        that.loading = false;
      })
    },
    openLog(row,type) {
      const that=this;
      if(type==1){
        that.$refs.houseUrgeLockHistoryDialogRef.show({
          url:"HouseUrgeLockHistory/index",
          project_ids:row.project_ids,
          area_ids:row.area_ids,
          area_id:row.area_id,
          year_month:that.where.yaer_month,
          urge_types:'自催',
          debt_age_type:row.age_type_text,
        });
      }else {
        that.$refs.houseUrgeLockHistoryDialogRef.show({
          url:"HouseUrgeLockHistory/index",
          project_ids:row.project_ids,
          area_ids:row.area_ids,
          area_id:row.area_id,
          year_month:that.where.yaer_month,
          urge_types:'第三方管理',
          debt_age_type:row.age_type_text,
        });
      }
    },
    initUrgeType(urge_type){
      const that=this;
      if(!that.reginWhere.project_ids&&!that.reginWhere.project_name){
        that.$message.error("请选择项目");
        return false;
      }
      if(!that.where.yaer_month){
        that.$message.error("请选择月份");
        return false;
      }
      that.$refs.ConfirmDialogRef.show({
        title: '计划校准提示',
        content: `
        <div style="font-size: 18px;line-height: 1.5;color:#000000;width: 100%;">
<p>1.校准计划是相对的，因为欠费金额、欠费房产等都会随时间变化而变化。每次触发，计数都会减小。</p>
<p>2.校准是基于已经做了计划的房产进行的重新统计计数，如果异常请查看【催缴房产】的明细统计。</p>
<p>3.校准是存在计数风险的，因为月初计数和月末计数可能存在偏差，请谨慎操作。</p>
</div>
        `,
        delayTimer:3,
        confirmFn: () => {
          that.loading = true;
          ButlerHttp.post("HouseUrge/initUrgeType",{
            project_ids:that.reginWhere.project_ids,
            project_id:that.reginWhere.project_name,
            year_month:that.where.yaer_month,
            urge_type:urge_type
          },res => {
            that.loading = false;
            if (res.code) {
              that.getList();
              that.$message.success("初始化成功");
            }else {
              that.$message.error(res.msg||'初始化异常');
            }
          });
        },
        cancelFn: () => {
          that.$message.error("取消操作");
        }
      });
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange();
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange();
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange();
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange();
      },500,that);
    },
    "where.yaer_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange();
      },500,that);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content2{
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LegalHouseAge.vue